import './index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { Analytics } from '@vercel/analytics/react'
import App from './App.jsx'
import { AuthProvider } from './components/AuthContext.jsx'

console.log('=== MAIN.JSX LOADING WITH FULL APP ===');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              style: {
                background: '#00696b',
              },
            },
            error: {
              style: {
                background: '#ba1a1a',
              },
            },
          }}
        />
        <Analytics />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)